import request from '@/util/request'
import store from '../store/store'
// 获取openid
export function getOpenId (code) {
  return request({
    url: `https://wx.aimtyiot.cn/wx/openid?code=${code}`,
    method: 'get'
  })
}
export function getOpenId1 (code) {
  return request({
    url: `https://wx.aimtyiot.cn/wx1/openid?code=${code}`,
    method: 'get'
  })
}
export function getOpenId2 (code) { // 测试
  return request({
    url: `https://wx.aimtyiot.cn/wx2/openid?code=${code}`,
    method: 'get'
  })
}
// 退出登录
export function logout () {
  let token = store.getters.get_token
  return request({
    url: '/logout',
    method: 'get',
    params: { token: token }
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js